var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timeseries.length > 0)?_c('highcharts',{ref:"chart",staticClass:"chart",attrs:{"options":_vm.processedSeries,"update-args":_vm.updateArgs}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }